import { PhLeaf } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type LocationsSectionCreate,
  type LocationsSection,
  type WebsiteResource,
  type LocationsSectionUpdate,
} from '../../WebsiteBuilder.types'
import { websiteBlockMethods } from '../common/methods'

import { createLocationsData } from './methods/createLocationsData'
import LocationsPreview from './preview/LocationsPreview.vue'
const i18n = i18nPlugin.global

export const LocationsBlockModule: BuilderBlockModule<
  LocationsSection,
  LocationsSectionCreate,
  LocationsSectionUpdate,
  WebsiteResource
> = {
  canAdd: false,
  canDelete: false,
  canReorderDown: false,
  canReorderUp: false,
  createData: createLocationsData,
  meta: [
    {
      icon: PhLeaf,
      key: 'locations',
      label: i18n.t('website-builder.blocks.locations'),
    },
  ],
  methods: websiteBlockMethods,
  preview: LocationsPreview,
}
